import UnidadeArmazenamento from "../components/classes/UnidadeArmazenamento";
import UnidadeArmazenamentoDataSet from "../components/data/UnidadeArmazenamentoDataSet";

export default class SkuHelper {
    listaSku: UnidadeArmazenamento[] = [];
    constructor() {
        this.listaSku = (new UnidadeArmazenamentoDataSet()).ListarFromCache();
    }

    eValido(value: number): boolean {
        let result: boolean = this.listaSku.filter(f => f.idSKU === value).length === 1;
        return result;
    }

    GetDescricao(value: number): string {
        let result: string = "";
        if (this.listaSku.filter(f => f.idSKU === value).length === 1)
            result = this.listaSku.filter(f => f.idSKU === value)[0].descricao;
        return result;
    }

    eMateriaPrima(value: number): boolean {
        let result: boolean = this.listaSku.filter(f => f.idSKU === value && f.tipoMaterial === "MateriaPrima").length === 1;
        return result;
    }

    getAll(): UnidadeArmazenamento[] {
        return this.listaSku.filter(f => f.d_E_L_E_T_E === false);
    }

    static getSKUName = (idSku: number): string => {
        let nome: string = "-";
        try {
            let objeto: UnidadeArmazenamento = (new UnidadeArmazenamentoDataSet()).ListarFromCache().filter(f => f.idSKU === idSku)[0];
            nome = objeto.descricao;
        }
        catch (error) {
            
        }
        return nome;
    }

}